import { TimeSlot, TimeSlotStructure, TimeSlotStructureType, TimeSlotType } from "../model/TimeSlotStructure";

export const getExamTimeSlots = (timeSlotStructure: TimeSlotStructure, timeSlotStructureType: TimeSlotStructureType) =>
  timeSlotStructure[timeSlotStructureType].filter((timeSlot) => timeSlot.type === TimeSlotType.Exam);

export const getTimeSlotLabel = (timeSlot: TimeSlot) => {
  return `${timeSlot.startTime} - ${timeSlot.endTime}`;
};

export const getExamTimeSlotLabelByIndex = (
  timeSlotStructure: TimeSlotStructure,
  timeSlotStructureType: TimeSlotStructureType,
  examTimeSlotIndex: number
) => {
  const timeSlot = getExamTimeSlotByIndex(timeSlotStructure, timeSlotStructureType, examTimeSlotIndex);
  return timeSlot !== undefined ? getTimeSlotLabel(timeSlot) : "";
};

const getExamTimeSlotByIndex = (
  timeSlotStructure: TimeSlotStructure,
  timeSlotStructureType: TimeSlotStructureType,
  examTimeSlotIndex: number
): TimeSlot | undefined =>
  getExamTimeSlots(timeSlotStructure, timeSlotStructureType).find((timeSlot) => timeSlot.index === examTimeSlotIndex);
